import { createBrowserRouter, Navigate } from 'react-router-dom';
import DashboardLayout from '../components/Layout/DashboardLayout';
import ProtectedRoute from '../components/ProtectedRoute';

// Pages
import Login from '../pages/Login';
import Register from '../pages/Register';
import Dashboard from '../pages/Dashboard';
import StudentList from '../pages/Students/StudentList';
import StudentForm from '../pages/Students/StudentForm';
import StudentDetail from '../pages/Students/StudentDetail';
import PaymentList from '../pages/Payments/PaymentList';
import CreatePayment from '../pages/Payments/CreatePayment';
import PaymentDetail from '../pages/Payments/PaymentDetail';
import ParentList from '../pages/Parents/ParentList';
import ParentForm from '../pages/Parents/ParentForm';
import ParentDetail from '../pages/Parents/ParentDetail';
import TeacherList from '../pages/Teachers/TeacherList';
import TeacherForm from '../pages/Teachers/TeacherForm';
import TeacherDetail from '../pages/Teachers/TeacherDetail';
import SchoolYearList from '../pages/SchoolYears/SchoolYearList';
import SchoolYearForm from '../pages/SchoolYears/SchoolYearForm';
import SchoolYearDetail from '../pages/SchoolYears/SchoolYearDetail';
import BalanceWidget from '../components/BalanceWidget';
import TeacherPaymentList from '../pages/TeacherPayments/TeacherPaymentList';
import TeacherPaymentForm from '../pages/TeacherPayments/TeacherPaymentForm';
import TeacherPaymentDetail from '../pages/TeacherPayments/TeacherPaymentDetail';
import OfferingList from '../pages/Offerings/OfferingList';
import OfferingForm from '../pages/Offerings/OfferingForm';
import OfferingDetail from '../pages/Offerings/OfferingDetail';
import AdditionalPaymentList from '../pages/AdditionalPayments/AdditionalPaymentList';
import AdditionalPaymentForm from '../pages/AdditionalPayments/AdditionalPaymentForm';
import AdditionalPaymentDetail from '../pages/AdditionalPayments/AdditionalPaymentDetail';
import ExpenseList from '../pages/Expenses/ExpenseList';
import ExpenseForm from '../pages/Expenses/ExpenseForm';
import ExpenseDetail from '../pages/Expenses/ExpenseDetail';
import TransactionHistory from '../pages/Transactions/TransactionHistory';
import FinancialReports from '../pages/Reports/FinancialReports';

export const router = createBrowserRouter([
  // Public Routes
  {
    path: "/login",
    element: <Login />
  },
  {
    path: "/register",
    element: <Register />
  },
  
  // Dashboard
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <DashboardLayout>
          <Dashboard />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  
  // Students
  {
    path: "/students",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <StudentList />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/students/new",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <StudentForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/students/:id",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <StudentDetail />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/students/:id/edit",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <StudentForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  
  // Monthly Payments
  {
    path: "/monthly-payments",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <PaymentList />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/monthly-payments/new",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <CreatePayment />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/monthly-payments/:id",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <PaymentDetail />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/monthly-payments/:id/edit",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <CreatePayment />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  
  // Parents
  {
    path: "/parents",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <ParentList />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/parents/new",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <ParentForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/parents/:id",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <ParentDetail />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/parents/:id/edit",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <ParentForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  
  // Teachers
  {
    path: "/teachers",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <TeacherList />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/teachers/new",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <TeacherForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/teachers/:id",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <TeacherDetail />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/teachers/:id/edit",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <TeacherForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  ////////Cursos/////////////////
  {
    path: "/school-years",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <SchoolYearList />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/school-years/new",
    element: (
      <ProtectedRoute roles={['admin']}>
        <DashboardLayout>
          <SchoolYearForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/school-years/:id",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <SchoolYearDetail />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/school-years/:id/edit",
    element: (
      <ProtectedRoute roles={['admin']}>
        <DashboardLayout>
          <SchoolYearForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/teacher-payments",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <TeacherPaymentList />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/teacher-payments/new",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <TeacherPaymentForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/teacher-payments/:id",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <TeacherPaymentDetail />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/teacher-payments/:id/edit",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <TeacherPaymentForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {/*
    path: "/teacher-payments/:id/pdf",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <TeacherPaymentPDF />
        </DashboardLayout>
      </ProtectedRoute>
    )
  */},
  {
    path: "/teacher-payments/teacher/:teacherId",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <TeacherPaymentList />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/balance",
    element: (
      <ProtectedRoute roles={['admin']}>
        <DashboardLayout>
          <BalanceWidget />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/donations",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <OfferingList />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/donations/new",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <OfferingForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/donations/:id",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <OfferingDetail />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/donations/:id/edit",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <OfferingForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/offerings",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <OfferingList />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/offerings/new",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <OfferingForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/offerings/:id",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <OfferingDetail />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/offerings/:id/edit",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <OfferingForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },  
  {
    path: "/additional-payments",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <AdditionalPaymentList />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/additional-payments/new",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <AdditionalPaymentForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/additional-payments/:id",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <AdditionalPaymentDetail />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/additional-payments/:id/edit",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <AdditionalPaymentForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/expenses",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <ExpenseList />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/expenses/new",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <ExpenseForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/expenses/:id",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <ExpenseDetail />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/expenses/:id/edit",
    element: (
      <ProtectedRoute roles={['admin', 'manager']}>
        <DashboardLayout>
          <ExpenseForm />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/balance/transactions",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <TransactionHistory />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/reports/financial",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <FinancialReports />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/reports/balance",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <FinancialReports />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/reports/morosos",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <FinancialReports />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/reports/ingresos-gastos",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <FinancialReports />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/reports/donantes",
    element: (
      <ProtectedRoute roles={['admin', 'manager', 'viewer']}>
        <DashboardLayout>
          <FinancialReports />
        </DashboardLayout>
      </ProtectedRoute>
    )
  },
  // Redirects
  {
    path: "/",
    element: <Navigate to="/dashboard" replace />
  },
  
  // 404
  {
    path: "*",
    element: (
      <div style={{ padding: 20 }}>
        <h2>404: Página no encontrada</h2>
        <p>La página que buscas no existe.</p>
      </div>
    )
  }
]);